import { useQueryParamContext } from 'modules/templateEditor/context/QueryParamContext';
import { FC } from 'react';
import { useTemplateTypeAndLocalesById } from '../../hooks/useTemplateTypeAndLocalesById';
import {
  TemplateTypeAndLocalesQueryContext,
  TemplateTypeAndLocalesQueryContextState,
} from './TemplateTypeAndLocalesQueryContext';

export const TemplateTypeAndLocalesQueryContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const { templateId: id = 0 } = useQueryParamContext();

  const templateResp = useTemplateTypeAndLocalesById({ variables: { id } });

  const { results: templateTypeAndLocaleResults } = templateResp;

  const { templateType, localeContents } = templateTypeAndLocaleResults?.templateAndContent || {};

  const context: TemplateTypeAndLocalesQueryContextState = {
    templateType,
    localeContents,
  };

  return (
    <TemplateTypeAndLocalesQueryContext.Provider value={context}>
      {children}
    </TemplateTypeAndLocalesQueryContext.Provider>
  );
};
